import React from 'react'
import { Link } from 'react-router-dom'

export default function SelectNav ({ back, nextLink }) {
  return (
    <ul className='bottom-nav'>
      <li className='return link'>
        {back 
          ? <span className='active'>
              <Link to={back}>
                {'< Return'}
              </Link>
            </span> 
          : <span className='inactive'>
              {'< Return'}
            </span>
        }
      </li>
      <li className='next link'>
        {nextLink 
          ? <span className='active'>
              <Link to={nextLink}>
                {'Next >'}
              </Link>
            </span> 
          : <span className='inactive'>
              {'Next >'}
            </span>}
      </li>
    </ul>
  )
}


// WEBPACK FOOTER //
// ./src/components/Users/Licenses/SelectNav.js